export default "__VITE_ASSET__717fe937__"